import React from 'react';
import './ModernBlocks.css';

const StatsBlock = ({ data }) => {
  return (
    <section className="stats-section">
      <div className="stats-container">
        <h2 className="stats-title">
          {data.title}
        </h2>
        <div className="stats-grid">
          {data.items.map((item, index) => (
            <div key={index} className="stat-item">
              <div className="stat-number">
                {item.number}
              </div>
              <h3 className="stat-label">
                {item.label}
              </h3>
              <p className="stat-description">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBlock; 